import React from 'react';

/** 开关 (role=switch). 放在可点击的父级 (如整行链接) 里时, 点击不会冒泡 / 触发父级默认跳转. */
export default function Switch({
    on,
    onChange,
    title,
    tone = 'brand',
}: {
    on: boolean;
    onChange: (next: boolean) => void;
    title?: string;
    /** 开启态配色: brand 主色 / danger 红 (用于「禁用」这类负向开关) */
    tone?: 'brand' | 'danger';
}) {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={on}
            title={title}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onChange(!on);
            }}
            className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors ${
                on
                    ? tone === 'danger'
                        ? 'bg-rose-500'
                        : 'bg-brand-600'
                    : 'bg-slate-300'
            }`}
        >
            <span
                className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
                    on ? 'translate-x-4' : 'translate-x-0.5'
                }`}
            />
        </button>
    );
}
